import React from 'react';
import { ThreeDots } from 'react-loader-spinner';
import './Load.css';

interface LoadProps {
  isLoading: boolean;
}

export const Load: React.FC<LoadProps> = ({ isLoading }) => {
  return (
    <div>
      {isLoading ? (
        <div className={`fade-load ${isLoading ? 'show-load' : 'hide-load'}`}>
          <ThreeDots
            visible={true}
            height={80}
            width={80}
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            color="#0066CC" 
            wrapperClass="dna-wrapper"
          />
        </div>
      ) : null}
    </div>
  );
}